// UI only for now (user decision 2026-09-24): Announcement settings has no api calls; these are the spec's placeholder values.

export interface RuleSet {
    email: boolean;
    confirm: boolean;
}

export interface Approver {
    name?: string;
    email: string;
}

export interface AnnouncementForm {
    priceSensitive: RuleSet;
    other: RuleSet;
    filters: string[];
    approvers: Approver[];
    remind: boolean;
    asx: { template: string; subject: string };
    welcome: { template: string; subject: string; send: boolean; when: string };
    // extra addresses that get test sends, besides the signed-in user
    testEmails: string[];
    social: { priceSensitive: boolean; afterApproval: boolean; askRoutine: boolean; picture: boolean; wording: string };
    domain: { domain: string; from: string; replyTo: string };
}

export const initialForm = (ticker: string, short: string): AnnouncementForm => ({
    priceSensitive: { email: true, confirm: true },
    other: { email: false, confirm: true },
    filters: ['Appendix 3Y', 'Appendix 3B', 'Application for quotation', 'Change of Director', 'Cleansing notice', 'Notice of Meeting'],
    approvers: [
        { name: 'Sam Taylor', email: 's.taylor@49metals.com.au' },
        { name: 'Cameron Reid', email: 'cameron@reidconsulting.example' },
    ],
    remind: true,
    asx: {
        template: 'asx-system',
        subject: `${ticker} New Announcement – {{announcement_headline}}`,
    },
    welcome: { template: 'welcome-system', subject: `Welcome to ${short} investor updates`, send: true, when: 'now' },
    testEmails: [],
    social: {
        priceSensitive: true,
        afterApproval: true,
        askRoutine: true,
        picture: false,
        wording: `{{announcement_headline}}\n\nRead the full announcement: {{announcement_link}}\n\n#ASX #${ticker} #gold`,
    },
    domain: { domain: '49metals.com.au', from: 'ir@49metals.com.au', replyTo: 'ir@49metals.com.au' },
});

export const STANDARD_FILTERS = [
    { word: 'Appendix 3Y', hint: 'Change of director’s interest' },
    { word: 'Appendix 3B', hint: 'New issue announcement' },
    { word: 'Appendix 2A', hint: 'Application for quotation of securities' },
    { word: 'Cleansing notice', hint: 'Section 708A notice' },
    { word: 'Notice of meeting', hint: 'AGM and EGM notices' },
    { word: 'Change of address', hint: 'Registered office changes' },
    { word: 'Becoming a substantial holder', hint: 'Form 603 / 604 / 605' },
    { word: 'Trading halt', hint: 'Some companies do want these emailed' },
];

export const ASX_TEMPLATES = [
    { value: 'asx-system', label: 'ASX Announcement (system template)' },
    { value: 'asx-brand', label: 'ASX Announcement (brand template)' },
];
export const WELCOME_TEMPLATES = [
    { value: 'welcome-system', label: 'Welcome Email (system template)' },
    { value: 'welcome-brand', label: 'Welcome Email (brand template)' },
];
export const SEND_WHEN = [
    { value: 'now', label: 'Straight away after someone subscribes' },
    { value: 'hour', label: '1 hour after someone subscribes' },
    { value: 'morning', label: 'The next morning at 9:00 am after someone subscribes' },
];
export const TEST_ANNOUNCEMENTS = [
    { value: '3y', label: '1‑Sep‑26 · Appendix 3Y – Change of Director’s Interest' },
    { value: 'drill', label: '28‑Aug‑26 · 171m @ 0.9 g/t Gold Confirms Scale at Gold Mountain' },
    { value: 'quarterly', label: '31‑Jul‑26 · Quarterly Activities Report' },
];

export interface SocialAccount {
    id: string;
    name: string;
    kind: string;
    detail: string;
    connected: boolean;
}

export const SOCIAL_ACCOUNTS = (company: string, ticker: string): SocialAccount[] => [
    { id: 'linkedin', name: 'LinkedIn', kind: 'Company page · recommended', detail: 'Not connected', connected: false },
    { id: 'x', name: 'X', kind: 'Company account', detail: `@${ticker.replace(/[^A-Za-z0-9]/g, '')} · connected by Wallace Turner`, connected: true },
];

export const SAMPLE_POST = {
    title: '171m @ 0.9 g/t Gold Confirms Scale at Gold Mountain',
};

export const SENDING_HEALTH = [
    { label: 'Delivered', value: '99.4%' },
    { label: 'Bounced', value: '0.4%' },
    { label: 'Marked as spam', value: '0.0%' },
];
